import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { SessionStorageService } from "@app/core/services/web-storage.service";
import { TokenExchangeResponse, NgrpApiClient } from "@app/core/data-services";
import { WASAuthService } from "@app/core/services/was-auth.service";

export interface AuthServiceInterface {
  handleAuthentication(): void;
  goToOriginalRouteIfExists(): boolean;
  logout(): void;
}

@Injectable()
export class AuthService {
  private readonly storageKey = "ORIGINAL_ROUTE";

  constructor(
    private storage: SessionStorageService,
    private router: Router,
    private wasAuthService: WASAuthService,
    private ngrpApiClient: NgrpApiClient
  ) {}

  handleAuthentication(): void {
    this.saveCurrentRoute();

    const wasUrl = this.wasAuthService.getWASAuthUrl();
    window.location.href = wasUrl;
  }

  exchangeAuthorizationCode(code: string): Observable<TokenExchangeResponse> {
    return this.ngrpApiClient.exchangeCodeForToken(code);
  }

  goToOriginalRouteIfExists(): boolean {
    const savedRoute = this.loadSavedRoute();
    if (savedRoute.length) {
      this.clearSavedRoute();
      this.router.navigate(savedRoute);
      return true;
    }

    this.router.navigate(["/dashboard"]);
    return false;
  }

  logout(): void {
    this.clearSavedRoute();
    this.wasAuthService.redirectToWASLogout();
  }

  private saveCurrentRoute(): void {
    const segments = this.getCurrentRouteSegments();
    if (segments.length && segments[0].split("?")[0] === "auth-callback") {
      return;
    }
    this.storage.set(this.storageKey, JSON.stringify(segments));
  }

  private loadSavedRoute(): Array<string> {
    const savedRoute = this.storage.get(this.storageKey);
    return savedRoute ? JSON.parse(savedRoute) : [];
  }

  private clearSavedRoute(): void {
    this.storage.remove(this.storageKey);
  }

  private getCurrentRouteSegments(): Array<string> {
    const hash = window.location.hash;
    if (!hash) {
      return [];
    }
    const segments = hash.split("/");
    if (segments[0] === "#") {
      segments.splice(0, 1);
    }
    return segments;
  }
}
